import PermitParkingSpotsPage from "./permitParkingSpots";

export default PermitParkingSpotsPage;